import {push} from 'connected-react-router'
import {useDispatch} from 'react-redux'
import Navigation from '../Navigation'

const LaunchPage = (props) => {
    const dispatch = useDispatch()

    return (
        <>
        <Navigation location={props.history.location.pathname}/>
        <div className={"container"}>
            <div className="row">
                <div className="col-xs-12">
                    <h1>Debt Management Agency Licence</h1>
                    <div id="summary">Apply for a Debt Management Agency Licence. You need the licence to employ poeple to collect debt in Nova Scotia on behalf of other companies. Business collecting their own debt do not need to be licensed as a Debt Management agency.</div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12 col-md-8">

                    <p>By law, Debt Management agenecies must have a Debt Management Agency Licence to employ people to collect debt in Nova Scotia on behalf of other companies. Businesses collecting their own debut do not need to be licensed as a Debt Management agency.</p>
                    <p>You need to become licensed in Nova Scotia before you can collect debts here, even if you're already licensed in another province. Debt Management agencies don't need to have a place of business in Nova Scotia. Debt Management can take place from outside the province, but must take place from within Canada.</p>
                    
                    <h2>Eligibility</h2>

                    <p>Your company needs to be registered with the Registry of Joint Stock Companies. Your company also needs to collect dept in Nova Scotia on behalf of other companies.</p>
                    
                    <h3>How to apply</h3>
                    <ol>
                        <li>Complete the online application form</li>
                        <li>Attach supporting documents</li>
                        <li>Pay for your application online.</li>
                    </ol>
                    
                    <h3>How long it takes</h3>
                    <p>It should take 5 business days to get the licence. It can take longer if more information is needed of if your application hasn't been filled in correctly. </p>
                    
                    <h3>Cost</h3>

                    <table className="table">
                        <thead>
                            <tr>
                                <th>Activity</th>
                                <th scope="col">Fee</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Licence (includes your first branch)</td>
                                <td>$466.75</td>
                            </tr>
                            <tr>
                                <td>Licence (each additional branch)</td>
                                <td>$165.70</td>
                            </tr>
                            <tr>
                                <td>Licence renewal (includes your first branch)</td>
                                <td>$464.75</td>
                            </tr>
                            <tr>
                                <td>Licence renewal (each additional branch)</td>
                                <td>$165.70</td>
                            </tr>
                        </tbody>
                    </table>

                    <h3>Payment Options</h3>
                    <p>Visa,MasterCard,Americal Express,cheque, money order. A cheque or money order should be made payable to the Minister of Finance. Payment options may vary depending on how you apply.</p>
                    
                    <h3>Before you start</h3>
                    <p>Make sure you have : </p>
                    <ul style={{listStyleType: " - "}}>
                        <li>Registry of Joint Stock Companies number.</li>
                        <li>name and address of financial insitution.</li>
                    </ul>
                    <p>If your Debt Management agency is located in another jurisdiction in Canada, you need to provide a copy of the Debt Management agency licence from your comnpan's province of residence. Include access to your account information and trust account records in Nova Scotia.</p>
                    
                    <p>You also need to decide if you or any partner, office or director has: </p>
                    <ul style={{listStyleType: ' - '}}>
                        <li>been licensed in another province or country</li>
                        <li>had a licence refused, suspended or revoked</li>
                    </ul>
                    
                    <p>You need to provide additional supporting documents including</p>
                    <ul style={{listStyleType: ' - '}}>
                        <li>original surety bond</li>
                        <li>confirmation from a Canadian financial institution</li>
                        <li>sample of each form or agreement</li>
                        <li>sample of each notice or form letter</li>
                    </ul>
                </div>

                <div className="col-sm-12 col-md-4">
                    <div className="secondary-content">
                    <h3>Contact</h3>
                        <p className="contact-link no-whitespace-bottom">
                            <a href="/contact/service-nova-scotia-and-internal-services/#SNS-BLS-01">Business Licensing Section</a>
                        </p>
                    </div>

                    <div className="secondary-content">
                        <h3>Related legislation</h3>
                        <ul>
                            <li><p className="contact-link no-whitespace-bottom"><a href="https://nslegislature.ca/sites/default/files/legc/statutes/collection agencies.pdf">Collection Agencies Act(pdf)</a></p></li>
                            <li><p className="contact-link no-whitespace-bottom"><a href="https://novascotia.ca/just/regulations/regs/caregs.htm">Collection Agencies Regulations</a></p></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="row bottomMarginMedium">
                <div className="col-lg-4">
                    <button 
                        id="debt-management-agency-start-new-application"
                        className="btn-lg btn-success"
                        onClick={() => {
                            // start new application
                            dispatch(push('/debt-management-agency/new/privacy-notice'))
                        }}>
                        Start New Application 
                        &nbsp;
                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                </div>
                <div className="col-lg-4">
                    <button 
                        id="debt-management-agency-renew-application"
                        className="btn-lg btn-info"
                        onClick={() => {
                            // start new application
                            dispatch(push('/debt-management-agency/renewal/privacy-notice'))
                        }}>
                        Renew Application 
                        &nbsp;
                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
        </>
    )
}

export default LaunchPage